export const NoticeType = {
  /**
   * A general notice. This type of system notices will be shown in a generic way. Can be used for messages like
   * Agent A has joined the chat, Agent B has joined the chat, etc.
   */
  GENERAL: 'notice.general',
  /**
   * A notice to represent that someone has joined the chat.
   */
  MEMBER_JOINED: 'notice.general.member.join',
  /**
   * A notice to represent that someone has left the chat.
   */
  MEMBER_LEFT: 'notice.general.member.left',
  /**
   * This notice should be shown only once. Can be used for messages like Queue position and agent typing. This
   * notice will hide once a new message/general notice is pushed to the message stack. If the new notice pushed is
   * of the same type, then the notice will be shown
   */
  STICKY: 'notice.sticky',
} as const;
